// Loại nhập số dư ban đầu
export default {
  /**
   * Số dư theo tài khoản ngân hàng
   */
  BankInitialBalance: 1,
  /**
   * Số dư theo đối tượng
   */
  ObjectInitialBalance: 2,
  /**
   * Số dư theo đối tượng và quyết định
   */
  ObjectDecisionInitialBalance: 3,
  /**
   * Số dư khác
   */
  OtherInitialBalance: 4,
  /**
   * Số dư theo tài sản và tang vật
   */
  AssetInitialBalance: 5,
};